export default __webpack_public_path__ + "static/media/footer-character.be74a0a4.png";